// Checklists in event descriptions, as the description's editor (Tiptap) writes them:
// <ul data-type="taskList"><li data-type="taskItem" data-checked="true"><label><input type="checkbox" checked>…

const ITEM = 'li[data-type="taskItem"]';

const parse = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    return template.content;
};

// How many of a description's checklist items are done, as { done, total }, or null when it has none.
export const taskProgress = (html) => {
    if (!html?.includes('taskItem')) return null;
    const items = [...parse(html).querySelectorAll(ITEM)];
    if (items.length === 0) return null;
    return { done: items.filter((item) => item.getAttribute('data-checked') === 'true').length, total: items.length };
};

// The description with its index-th checklist item, counted in document order, ticked or unticked.
export const toggleTask = (html, index) => {
    const root = parse(html);
    const item = root.querySelectorAll(ITEM)[index];
    if (!item) return html;
    const checked = item.getAttribute('data-checked') !== 'true';
    item.setAttribute('data-checked', String(checked));
    const box = item.querySelector(':scope > label > input[type="checkbox"]');
    if (box && checked) box.setAttribute('checked', 'checked');
    else if (box) box.removeAttribute('checked');
    const container = document.createElement('div');
    container.append(root);
    return container.innerHTML;
};
